const PREFIX = '[YouTube Shadowing]';
const DEBUG = false;

export const logger = {
  debug: (...args: unknown[]) => DEBUG && console.debug(PREFIX, ...args),
  info: (...args: unknown[]) => console.info(PREFIX, ...args),
  warn: (...args: unknown[]) => console.warn(PREFIX, ...args),
  error: (...args: unknown[]) => console.error(PREFIX, ...args),
};
